import { css } from 'lit';
import componentStyles from '../../styles/component.styles.js';
import { theme } from '../../themes/theme.js';
export default css `
    ${componentStyles}

    :host {
        display: block;
    }
    .fixed-layout {
        table-layout: fixed;
    }
    .table {
        ${theme.colors.cssColor('text-default')};
        ${theme.texts.cssBody('normal', 'S')};
        width: 100%;
    }

    .thead {
        ${theme.colors.cssBackground('neutral')}
        ${theme.texts.cssBody('bold', 'S')};
        text-transform: uppercase;
    }

    .thead .th {
        ${theme.spacings.cssPaddingX('XS')}
        ${theme.spacings.cssPaddingY('S')}
    }

    tbody .tr {
        background-color: white;
        border-bottom-width: 1px;
        border-bottom-style: solid;
        border-color: var(--sgdf-color-neutral-400);
    }

    tbody .tr:hover {
        ${theme.colors.cssBackground('neutral')}
    }

    tbody .tr .td {
        ${theme.spacings.cssPadding('XS')}
        overflow-y: hidden;
        width: 8rem;
    }

    .cursor-pointer {
        cursor: pointer;
    }

    .select-none {
        user-select: none;
    }

    .radio-button-success::part(button) {
        background-color: var(--sgdf-color-success-50);
    }
    .radio-button-success::part(button--checked),
    .radio-button-success::part(button):hover {
        background-color: var(--sgdf-color-success-600);
    }
    .radio-button-error::part(button) {
        background-color: var(--sgdf-color-danger-50);
    }
    .radio-button-error::part(button--checked),
    .radio-button-error::part(button):hover {
        background-color: var(--sgdf-color-danger-600);
    }
    .radio-button-warning::part(button) {
        background-color: var(--sgdf-color-warning-50);
    }
    .radio-button-warning::part(button--checked),
    .radio-button-warning::part(button):hover {
        background-color: var(--sgdf-color-warning-600);
    }
    .radio-button-gray::part(button) {
        background-color: var(--sgdf-color-gray-50);
    }
    .radio-button-gray::part(button--checked),
    .radio-button-gray::part(button):hover {
        background-color: var(--sgdf-color-gray-600);
    }
`;
//# sourceMappingURL=table-next.styles.js.map